<template>
	<main class="more benefit">
		<div v-if="getBannerMulti?.benefit_top && getBannerMulti?.benefit_top[0]?.banner_image_url" class="c_page_banner">
			<img
				:src="getBannerMulti?.benefit_top[0]?.banner_image_url ?? ''"
				alt="고객지원 배너"
				@click="
					onClickBanner(
						getBannerMulti?.benefit_top[0]?.banner_url ?? '',
						getBannerMulti?.benefit_top[0]?.banner_mo_url ?? ''
					)
				"
			/>
		</div>

		<article class="sub_info">
			<section
				v-if="getBannerMulti?.benefit && getBannerMulti?.benefit[0]?.banner_image_url"
				class="banner"
				@click="
					onClickBanner(getBannerMulti?.benefit[0]?.banner_url ?? '', getBannerMulti?.benefit[0]?.banner_mo_url ?? '')
				"
			>
				<img
					v-if="getBannerMulti?.benefit[0]?.banner_image_url"
					:src="getBannerMulti?.benefit[0]?.banner_image_url ?? ''"
					alt="img1"
				/>
			</section>
			<section class="c_tabMenu">
				<div
					class="c_tabMenu_item"
					:class="{ on: currentTab === '일반' }"
					@click="$router.replace({ query: { currentTab: '일반', page: 1 } })"
				>
					일반
				</div>
				<div
					class="c_tabMenu_item"
					:class="{ on: currentTab === '프리미엄' }"
					@click="$router.replace({ query: { currentTab: '프리미엄', page: 1 } })"
				>
					프리미엄
				</div>
			</section>
			<ul v-if="currentTab === '일반'" class="history_board">
				<li v-for="(item, idx) in benefitData?.post" :key="idx" @click="onClickNormalList(item.post_pk)">
					<p>{{ item.post_title }}</p>
					<p>{{ dayjs(item.post_enrollment_date).format('YYYY-MM-DD') }}</p>
				</li>
				<Pagination
					v-if="benefitData?.post_cnt"
					:current-page="Number(route.query.page ?? 1)"
					:total-count="benefitData?.post_cnt ? Math.ceil(benefitData?.post_cnt / 10) : 0"
					@set-page="
						async (page) => {
							router.replace({ query: { ...route.query, page: page } });
						}
					"
				/>
			</ul>
			<div v-if="currentTab === '프리미엄'" class="tab_board_wrap">
				<ul class="tab_board">
					<li @click="onClickPremiumList('ONE')">
						<span>구독 전용 게시판</span>
						<ArrowNextIcon />
					</li>
					<li @click="onClickPremiumList('PREMIUM')">
						<span>구독 전용 게시판 (차트영웅)</span>
						<ArrowNextIcon />
					</li>
					<li @click="onClickPremiumList('VIDEO')">
						<span>차트영웅 Live 녹화방송</span>
						<ArrowNextIcon />
					</li>
				</ul>
			</div>
		</article>
	</main>
	<HomePopup exposure-location="benefit" />
</template>

<script setup lang="ts">
// core
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import dayjs from 'dayjs';

import { useGetCheckAuthApi } from '@/api/auth';
import { useGetBannerMultiApi } from '@/api/banner';
// api
import { useGetPostBenefitApi } from '@/api/benefit';
// img
import ArrowNextIcon from '@/assets/img/common/arrow_next.svg?component';
// component
import HomePopup from '@/components/popup/HomePopup.vue';
// constant
import { CANCEL, CONFIRM_LOGIN, LOGIN_REQUIRED_PAGE } from '@/constants/title';
// store
import { useLoginPopupStore } from '@/stores/LoginPopup';
import { useModalStore } from '@/stores/modal';
import { useTokenStore } from '@/stores/token';
// util
import { checkLoginDetail } from '@/utils/function/login';

// -----variable-----
const route = useRoute();
const router = useRouter();

const modalStore = useModalStore();
const tokenStore = useTokenStore();
const loginPopupStore = useLoginPopupStore();

const num = ref();
const student = ref();

const currentTab = computed(() => {
	return (route.query.currentTab ?? '일반') as string;
});
// -----api-----
const { data: benefitData } = useGetPostBenefitApi(
	computed(() => {
		return { tab: 'NORMAL', page: Number(route.query.page ?? 1), row: 10 };
	})
);
const { data: getBannerMulti } = useGetBannerMultiApi({ type: 'benefit,benefit_top' });
const { refetch: checkAuthRefetch } = useGetCheckAuthApi(
	computed(() => {
		return {
			num: num.value,
			student: student.value,
		};
	})
);
// -----function-----
// 배너 클릭 시 실행 함수
const onClickBanner = async (url: string, moUrl: string) => {
	if (url.includes('shop.masterpick.co.kr') || moUrl.includes('shop.masterpick.co.kr')) {
		if (!tokenStore.isLogin) {
			loginPopupStore.openPopup({
				icon: 'alert',
				content: LOGIN_REQUIRED_PAGE,
				confirm: () => router.push('/auth/login'),
				confirmText: CONFIRM_LOGIN,
				cancelText: CANCEL,
			});
			return;
		}
		num.value = 'ONE';
		student.value = false;
		const res = await checkAuthRefetch();
		if (res.data?.success) {
			const targetUrl = `${import.meta.env.VITE_MALL_URL}/?access_token=${tokenStore.getAccessToken}`;
			let agent = navigator.userAgent.toLowerCase();
			if (agent.indexOf('android') !== -1) {
				window.location.href = targetUrl;
				return;
			} else if (agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) {
				window.location.href = targetUrl;
				return;
			} else {
				window.open(targetUrl);
				return;
			}
		} else {
			modalStore.openModal('GuideModal');
		}
	} else {
		const formatUrl = url.replace('https://www.masterpick.co.kr', '');
		router.push(formatUrl);
		// let agent = navigator.userAgent.toLowerCase();
		// if (agent.indexOf('android') !== -1 && window.masterpick) {
		// 	window.masterpick.nativeUrlOpenBrowser(moUrl);
		// } else if (
		// 	(agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) &&
		// 	window.webkit &&
		// 	window.webkit.messageHandlers &&
		// 	window.webkit.messageHandlers.nativeUrlOpenBrowser
		// ) {
		// 	window.location.href = url;
		// } else {
		// 	window.open(url, '_self');
		// }
	}
};

// 구독권한 결과에 따른 route설정
const checkAuthResult = ({ res, tab }: { res?: boolean; tab: string }) => {
	if (res) {
		router.push({
			name: 'subscriber-board',
			query: {
				tab: tab,
			},
		});
		return;
	} else {
		modalStore.openModal('GuideModal');
	}
};

// 일반 탬 클릭 시, 로그인 및 구독권한 확인
const onClickNormalList = (pk: number | string) => {
	router.push(`/subscriber-board-detail/${pk}`);
};

// 프리미엄 탭 클릭 시, 로그인 및 구독권한 확인
const onClickPremiumList = async (tab: string) => {
	if (!tokenStore.isLogin) {
		checkLoginDetail();
		return;
	}
	if (tab === 'ONE') {
		num.value = 'ONE';
		student.value = false;
		const res = await checkAuthRefetch();
		checkAuthResult({ res: res.data?.success, tab: tab });
	} else if (tab === 'PREMIUM') {
		num.value = 'ONE';
		student.value = false;
		const res = await checkAuthRefetch();
		checkAuthResult({ res: res.data?.success, tab: tab });
	} else if (tab === 'VIDEO') {
		num.value = 'ALL';
		student.value = false;
		const res = await checkAuthRefetch();
		checkAuthResult({ res: res.data?.success, tab: tab });
	}
};
</script>

<style lang="scss" scoped>
.benefit {
	display: flex;
	flex-direction: column;
	@media screen and (max-width: 1280px) {
		padding-bottom: 8rem;
	}
}
.benefit .sub_info {
	padding-bottom: 6.4rem;
	@media screen and (max-width: 1280px) {
		padding-bottom: 0rem;
	}
	h5 {
		padding: 0rem 2rem 2rem 2rem;
	}
}
.benefit .sub_info .c_tabMenu {
	color: var(--color-base-light);
}
.benefit .sub_info .history_board li {
	cursor: pointer;
	font-weight: var(--font-w-light);
	max-width: 68rem;
	width: 100%;
	p {
		max-width: 68rem;
		width: 100%;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
}
.benefit .sub_info .banner {
	margin-top: 6.4rem;
	margin-bottom: 5.6rem;
	@media screen and (max-width: 1280px) {
		margin-top: 4rem;
		margin-bottom: 4rem;
	}
}
.benefit .sub_info .banner img {
	height: 18rem;
	cursor: pointer;
	@media screen and (max-width: 1280px) {
		min-height: 12rem;
		height: 100%;
	}
}
.benefit .sub_info .tab_board {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 0 2rem;
}
.benefit .sub_info .tab_board li {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.6rem;
	border-radius: 0.8rem;
	font-weight: var(--font-w-light);
	font-size: var(--font-s-mid);
	line-height: 1.9rem;
	color: white;
	background-color: var(--color-bg-mid);
	cursor: pointer;
}
.pagination {
	margin-top: 2.4rem;
}
.benefit .main_banner {
	:deep(.swiper) {
		height: 100%;
		.swiper-slide > img {
			height: 60rem;
			@media screen and (max-width: 1280px) {
				height: 40rem;
			}
		}
	}
}
</style>
